export default __webpack_public_path__ + "static/media/locked.393f7aad.svg";